module.exports = __webpack_public_path__ + "img/x-octagon.387cb6b1.svg";